import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPayment$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPayment extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'efb014f0b45149910f91aa171f829e86e6bffbd2', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '405fd234b29f0dbacf8247b39418a63bf11eb12d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1c89a4032eb66e8843eabee52483ca73f6faefe3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 16.5v-11a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5m14.5-8v-2h-13v2zm-13 7V10h13v5.5zm3-3.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-payment", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-payment"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-payment":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPayment$1);
            }
            break;
    } });
}

const CosmosIconPayment = CosmosIconPayment$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPayment, defineCustomElement };
